import React, { useState, useRef, useEffect, useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'


// https://www.npmjs.com/package/react-xml-viewer
import XMLViewer from "react-xml-viewer";

/*
 * https://date-fns.org/v4.1.0/docs/addDays
 * https://www.npmjs.com/package/react-datepicker
 * https://reactdatepicker.com/#example-locale-without-global-variables
 */
import DatePicker from "react-datepicker";
import { registerLocale, setDefaultLocale } from  "react-datepicker";
import format from 'date-fns/format'
import { de } from 'date-fns/locale/de';

// Components
import AjaxController from '../system/ajaxController';

// Redux slices
import { setFilterValue, setSearching, setResult, addResult } from './settingsSlice';
import { setActivePage, setUser, setToken } from '../../appSlice';

// SemanticUI components
import { Button, Icon, Header, HeaderContent, Form, FormGroup, FormField, FormInput, FormSelect, Table, TableHeader, TableHeaderCell, TableRow, TableBody, TableCell, Grid, GridRow, GridColumn, Container } from 'semantic-ui-react'

// Style
import './settings.css';


registerLocale('de', de);
setDefaultLocale('de');







const Max2SettingsAllotmentsLogFilter = () => {
  // global State
  const dispatch = useDispatch();
  const backendUrl    = useSelector((state) => state.app.backend.baseProtocol) + '://' + useSelector((state) => state.app.backend.url);
  const searchFilter  = useSelector((state) => state.settings.filter);
  const pagination    = useSelector((state) => state.settings.pagination); 
  
  // translation
  const { t } = useTranslation();

  //
  const optionsType = [
    {key: 'GET', value: 'GET', text: t('common.get')}, 
    {key: 'PUT', value: 'PUT', text: t('common.put')}
  ]



  /**
   * Handles changes in filter form fields
   * 
   * @param {string} filter
   * @param {string} action
   * @param {mixed} value  
   */
  const handleFilter = (filter, action, value) => {
    switch (action) {
      case 'SET':     dispatch(setFilterValue({filter: filter, value: value})); break;
      default: break;
    }
  }


  /**
   * Sends the filter request 
   * http://localhost:8080/filter/W29iamVjdCBPYmplY3Rd
   * 
   */
  const handleFilterClick = () => {
    // encode filter params object
    const query = {
      filter: searchFilter, 
      pagination: pagination,
      sorting: { by: 'log_date', direction: 'DESC' }
    }
    
    // Controller for AJAX requests
    const api = new AjaxController(backendUrl, () => {
          dispatch(setActivePage('START'));
          dispatch(setUser(null));
          dispatch(setToken(null));
        });
    
    // search for hotels
    const fetchData = async () => {
      try {

        // show loading animation
        dispatch(setSearching(true));

        // send search request
        const count = await api.get('/settings/allotment_log_count/' + btoa(JSON.stringify(query)).replaceAll('=', '_'));
        const response = await api.get('/settings/allotment_log_filter/' + btoa(JSON.stringify(query)).replaceAll('=', '_'));

        // hide loading animation
        dispatch(setSearching(false));

        // display results
        dispatch(setResult({result: response, numberOfRecordsTotal: count}))

      } catch (err) {
        //setError(err.message);
        console.error(err.message)
      }
    };

    fetchData();
  }
  

  return (
    <Form>
      <FormGroup>
        <DatePicker
          showWeekNumbers
          isClearable
          selected    = {searchFilter.log_date_from.value}
          dateFormat  = "dd.MM.yyyy"
          placeholder = 'TT.MM.JJJJ'
          onChange    = {(date, formElement)=>handleFilter('log_date_from', 'SET', date ? format(date, "yyyy-MM-dd") : null)} 
          customInput = {<FormInput icon='calendar alternate' iconPosition='left' label="von" placeholder='TT.MM.JJJJ' style={{width: "150px"}} />}
        />
        <DatePicker
          showWeekNumbers
          isClearable
          selected    = {searchFilter.log_date_to.value}
          dateFormat  = "dd.MM.yyyy"
          placeholder = 'TT.MM.JJJJ'
          onChange    = {(date, formElement)=>handleFilter('log_date_to', 'SET', date ? format(date, "yyyy-MM-dd") : null)} 
          customInput = {<FormInput icon='calendar alternate' iconPosition='left' label="bis" placeholder='TT.MM.JJJJ' style={{width: "150px"}} />}
        />

        <FormInput 
          fluid 
          label       = 'Benutzer' 
          placeholder = 'Benutzer' 
          style       = {{width: '150px'}} 
          value       = {searchFilter.log_user.value}
          onChange  = {(event, formElement)=>handleFilter('log_user', 'SET', formElement.value)} 
        />

        <FormSelect
          fluid
          clearable
          style       = {{width: '150px'}} 
          label       = 'Typ'
          options     = {optionsType}
          placeholder = 'bitte wählen'
          value       = {searchFilter.log_type.value}
          onChange    = {(event, formElement)=>handleFilter('log_type', 'SET', formElement.value)} 
        />

        <FormInput 
          fluid 
          label       = 'Hotelcode' 
          placeholder = 'Hotelcode' 
          style       = {{width: '150px'}} 
          value       = {searchFilter.log_hotelcode.value}
          onChange    = {(event, formElement)=>handleFilter('log_hotelcode', 'SET', formElement.value)} 
        />

        <FormField style={{paddingTop: '25px'}}>
          <Button primary circular icon labelPosition='left' onClick={()=>handleFilterClick()}><Icon name="filter" /> Filtern</Button>
        </FormField>  
      </FormGroup>
    </Form>
  )
}








const Max2SettingsAllotmentsLog = () => {
  // local state
  const [isLoading, setIsLoading] = useState(false);
  const [details, setDetails] = useState(null);
  
  // global State
  const dispatch = useDispatch();
  const backendUrl    = useSelector((state) => state.app.backend.baseProtocol) + '://' + useSelector((state) => state.app.backend.url);
  const searchFilter  = useSelector((state) => state.settings.filter);
  const pagination    = useSelector((state) => state.settings.pagination);
  const searchResult  = useSelector((state) => state.settings.result)
  const isSearching   = useSelector((state) => state.settings.isSearching)
  const isFiltered    = useSelector((state) => state.settings.isFiltered)

  // translation
  const { t } = useTranslation();

  // Define references
  const loadMoreRef = useRef(null);

  // xml viewer styles
  const customTheme = {
    attributeKeyColor: "#0074D9",
    attributeValueColor: "#2ECC40"
  };



  /**
   * Load additional records
   */
  const loadMoreItems = useCallback(() => {
    // show load more animation
    setIsLoading(true);
    
    // Controller for AJAX requests
    const api = new AjaxController(backendUrl, () => {
          dispatch(setActivePage('START'));
          dispatch(setUser(null));
          dispatch(setToken(null));
        });
    
    // encode filter params object
    const query = {
      filter: searchFilter, 
      pagination: {
        ...pagination,
        actualPage: (pagination.actualPage+1)
      },
      sorting: { by: 'log_date', direction: 'DESC' }
    }
    
    // search for hotels
    const fetchData = async () => {
      try {
        const response = await api.get('/settings/allotment_log_filter/' + btoa(JSON.stringify(query)).replaceAll('=', '_'));

        // hide load more animation
        setIsLoading(false);

        // extend result list
        dispatch(addResult(response))

      } catch (err) {
        console.error(err.message)
      }
    };

    fetchData();
  }, [backendUrl, dispatch, pagination, searchFilter]);

  /**
   * Initialize the scoll observer
   */
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          loadMoreItems();
        }
      },
      { threshold: 1.0 }
    );

    const currentRef = loadMoreRef.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [loadMoreItems]);


  const handleRowClick = (id) => {
    searchResult.records.forEach(record => {
      if (record.log_id === id) {
        setDetails(
          {
            log_id:               record.log_id,
            log_date:             format(new Date(record.log_date), 'dd.MM.yyyy HH:mm:ss'),
            log_type:             record.log_type,
            log_hotelcode:        record.log_hotelcode,
            log_user_name:        record.log_user_name,
            log_request_url:      record.log_request_url,
            log_request_payload:  record.log_request_payload,
            log_response_code:    record.log_response_code,
            log_response_payload: record.log_response_payload
          }
        )
      }
    });
  }
  

  // Build result records
  const resultItems = searchResult.records.map((logRecord) => {
    const log_date = format(new Date(logRecord.log_date), 'dd.MM.yyyy HH:mm:ss');
    return (
      <TableRow active={details && details.log_id === logRecord.log_id ? true : false} key={logRecord.log_id}>
        <TableCell style={{paddingRight: "30px"}} onClick={()=>handleRowClick(logRecord.log_id)}>{log_date}</TableCell>
        <TableCell style={{paddingRight: "30px"}} onClick={()=>handleRowClick(logRecord.log_id)}>{logRecord.log_user_name}</TableCell>
        <TableCell style={{paddingRight: "30px"}} onClick={()=>handleRowClick(logRecord.log_id)}>{logRecord.log_type}</TableCell>
        <TableCell style={{paddingRight: "30px"}} onClick={()=>handleRowClick(logRecord.log_id)}>{logRecord.log_hotelcode}</TableCell>
        <TableCell style={{paddingRight: "40px"}} onClick={()=>handleRowClick(logRecord.log_id)}>{logRecord.log_response_code}</TableCell>
      </TableRow>
    )
  });
  

  if (isSearching) {
    return (
      <>
      <Header as='h4'>{t('common.filter')}</Header>
      <Max2SettingsAllotmentsLogFilter />
      <Header as='h2' textAlign='center'>
        <Icon loading name='spinner' />
        <HeaderContent>
          {t('search.result.loading')}
        </HeaderContent>
      </Header>
      </>
    )
  }

  // not yet filtered
  if (!searchResult.numberOfRecords && !isFiltered) {
    return (
      <>
      <Header as='h4'>{t('common.filter')}</Header>
      <Max2SettingsAllotmentsLogFilter />
      </>
    );
  }

  return (
    <>
    <Grid style={{margin: '25px'}}>
      <GridRow> 
        <GridColumn width={16}>
          <Header as='h4'>{t('common.filter')}</Header>
          <Max2SettingsAllotmentsLogFilter />
        </GridColumn>
      </GridRow>
      <GridRow>
        <GridColumn width={6}>
          <Header as='h4'>{t('settings.allotments.log_entries')}</Header>
          <Table basic='very' collapsing selectable>
            <TableHeader>
              <TableRow>
                <TableHeaderCell>Datum</TableHeaderCell>
                <TableHeaderCell>Benutzer</TableHeaderCell>
                <TableHeaderCell>Typ</TableHeaderCell>
                <TableHeaderCell>Hotelcode</TableHeaderCell>
                <TableHeaderCell>Response Code</TableHeaderCell>
              </TableRow>
            </TableHeader>

            <TableBody>
              {resultItems}
            </TableBody>
          </Table>

          {searchResult.numberOfRecords !== searchResult.numberOfRecordsTotal && (
            <div ref={loadMoreRef} style={{ textAlign: "center", padding: "10px" }}>
              {isLoading ? (
                <Button basic circular loading icon><Icon loading name="spinner" />{t('common.loading')}...</Button>
              ) : (
                <Button basic circular onClick={loadMoreItems}>{t('common.load_more')}</Button>
              )}
            </div>
          )}
        </GridColumn>
        {details && (
          <GridColumn width={10}>
            <Header as='h4'>{t('settings.allotments.log_details')}</Header>
          
              <Form>
                <FormInput fluid readOnly label={t('settings.allotments.log_date')} value={details.log_date} />
                <FormInput fluid readOnly label={t('settings.allotments.log_type')} value={details.log_type} />
                <FormInput fluid readOnly label={t('settings.allotments.log_hotelcode')} value={details.log_hotelcode} />
                <FormInput fluid readOnly label={t('settings.allotments.log_user')} value={details.log_user_name} />
                <FormInput fluid readOnly label={t('settings.allotments.log_request_url')} value={details.log_request_url} />
                <FormField>
                  <label>{t('settings.allotments.request_data')}</label>
                  <Container style={{paddingLeft: '25px', border: '1px solid silver', borderRadius: '15px', background: '#f9f9ff'}}>
                    <XMLViewer xml={details.log_request_payload} theme={customTheme} collapsible />
                  </Container>
                </FormField>
                <FormInput fluid readOnly label={t('settings.allotments.log_response_code')} value={details.log_response_code} />
                <FormField>
                  <label>{t('settings.allotments.response_data')}</label>
                  <Container style={{paddingLeft: '25px', border: '1px solid silver', borderRadius: '15px', background: '#f9f9ff', maxHeight: '500px', overflow: 'auto'}}>
                    <XMLViewer xml={details.log_response_payload} theme={customTheme} collapsible />
                  </Container>
                </FormField>
              </Form>
          
          </GridColumn>
        )}
      </GridRow>
    </Grid>
    </>
  )
}

export default Max2SettingsAllotmentsLog;